<template>
  <div :class="{row: true}">
    <div class="question-box">
      <Bot :data="object.bot"/>
    </div>
    <div class="answer-box">
      <Answer :data="object.answer"/>
    </div>
  </div>
</template>

<script>
import Bot from './Bot'
import Answer from './Answer'

export default {
  name: 'Row',
  props: {
    object: Object
  },
  components: {
    Bot,
    Answer
  }
}
</script>

<style lang="scss" scoped>
.row {
  width: 100%;
  height: auto;
  min-height: 8rem;
  display: flex;
  flex-direction: row;
  margin-top: 2rem;
  @media (max-width: 750px) {
    flex-direction: column;
  }
}

.question-box {
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-end;
  padding-right: 1rem;
  @media (max-width: 750px) {
    min-height: 6rem;
    height: auto;
    width: 100%;
    flex: unset;
    margin-bottom: 1rem;
    align-items: center;
    padding-right: 0;
  }
}

.answer-box {
  height: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  padding-left: 1rem;
  @media (max-width: 750px) {
    min-height: 4rem;
    height: auto;
    width: 100%;
    flex: unset;
    align-items: center;
    padding-left: 0;
  }
}

</style>